import { useState } from "react";
import { Check, UserMinus } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";

export const AttendanceToggle = ({ booking, endpoint, onChanged, testPrefix = "attendance" }) => {
  const [busy, setBusy] = useState(false);
  const current = booking.attendance || null;

  const set = async (status) => {
    setBusy(true);
    try {
      await api.post(`${endpoint}/${booking.id}/attendance`, { status: current === status ? "clear" : status });
      onChanged();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-1" data-testid={`${testPrefix}-${booking.id}`}>
      <button onClick={() => set("attended")} disabled={busy} title="Showed up"
        className={`tracker text-[9px] px-2 py-1 border inline-flex items-center gap-1 ${current === "attended" ? "border-emerald-500 bg-emerald-500/15 text-emerald-300" : "border-white/10 text-zinc-500 hover:text-zinc-300"}`}
        data-testid={`${testPrefix}-here-${booking.id}`}>
        <Check size={10} weight="bold" /> HERE
      </button>
      <button onClick={() => set("no_show")} disabled={busy} title="Didn't show"
        className={`tracker text-[9px] px-2 py-1 border inline-flex items-center gap-1 ${current === "no_show" ? "border-red-500 bg-red-500/15 text-red-300" : "border-white/10 text-zinc-500 hover:text-zinc-300"}`}
        data-testid={`${testPrefix}-noshow-${booking.id}`}>
        <UserMinus size={10} weight="bold" /> NO-SHOW
      </button>
    </div>
  );
};

export const NoShowBadge = ({ booking, testPrefix = "noshows" }) =>
  booking.attendee_no_shows > 0 ? (
    <span className="tracker text-[9px] px-1.5 py-0.5 border border-red-500/30 text-red-400" title={`${booking.attendee_no_shows} no-show${booking.attendee_no_shows === 1 ? "" : "s"} · ${booking.attendee_attended || 0} attended with you`} data-testid={`${testPrefix}-${booking.id}`}>
      {booking.attendee_no_shows}× NO-SHOW
    </span>
  ) : null;

export const AttendanceSummary = ({ cls, testId }) => {
  if (!cls.booked_count) return null;
  const marked = (cls.attended_count || 0) + (cls.no_show_count || 0);
  if (!marked) return null;
  return (
    <span className="tracker text-[9px] text-zinc-500" data-testid={testId}>
      {cls.attended_count || 0} attended{cls.no_show_count ? <span className="text-red-400"> · {cls.no_show_count} no-show{cls.no_show_count === 1 ? "" : "s"}</span> : null}
    </span>
  );
};
